<template>
  <DataTable :columns="columnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="4" :url="dataURL">
    <template v-slot:title>
      <h3>Toughening Batch List</h3>
    </template>
    <template v-slot:row="row">
      <tr :key="row.data.id">
        <td class="table-data-nav-link">
          <LinkTougheningBatch :id="row.data.id" :name="`#${row.data.sequenceNumber}`" :newTab="false" />
        </td>
        <td>
          {{row.data.sourceProductionStationName}}
        </td>
        <td>
          {{formatLookupName(row.data.complianceType, ToughenBatchComplianceTypeLookup)}}
        </td>
        <td>
          {{formatLookupName(row.data.glassType, ToughenBatchGlassTypeLookup)}}
        </td>
        <td>
          {{row.data.startTime | formatDateTime}}
        </td>
        <td>
          {{row.data.endTime | formatDateTime}}
        </td>
        <td>
          {{row.data.batchThickness}}mm
        </td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import { ToughenBatchComplianceTypeLookup, ToughenBatchGlassTypeLookup } from '@/store/types'

export default {
  name: 'TougheningBatchDataTable',
  components: {
  },
  props: {
    filterType: String,
    productionStageId: Number,
    productionStationId: Number
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {}
      }
      if(this.productionStageId)
        params.filter.productionStageId = parseInt(this.productionStageId)
      if(this.productionStationId)
        params.filter.sourceProductionStationId = parseInt(this.productionStationId)

      return '/production/tougheningbatches?' + $.param(params)
    },
  },
  data() {
    return {
      columnList: [
        { title: "Batch Number", data: "sequenceNumber" },
        { title: "Station", data: "sourceProductionStationName" },
        { title: "Compliance Type", data: "complianceType" },
        { title: "Glass Type", data: "glassType" },
        { title: "Start Time", data: "startTime" },
        { title: "End Time", data: "endTime" },
        { title: "Thickness", data: "batchThickness" }
      ]
    }
  },
  created() {
    this.ToughenBatchComplianceTypeLookup = ToughenBatchComplianceTypeLookup
    this.ToughenBatchGlassTypeLookup = ToughenBatchGlassTypeLookup
  },
  methods: {
  }
}
</script>
